__turbopack_context__.v({
  "root": "Score-module___qw5ea__root",
});
